const data = [
    { id: 1, animal: 'Лось, сибирский горный козел, овцебык', price: '40 000' },
    { id: 2, animal: 'Кабан, дикий северный олень, кабарга', price: '15 000' },
    { id: 3, animal: 'Благородный олень', price: '35 000' },
    { id: 4, animal: 'Пятнистый олень, лань, туры, сайгак', price: '30 000' },
    { id: 5, animal: 'Косули, муфлон, серна', price: '20 000' },
    { id: 6, animal: 'Снежный баран', price: '50 000' },
    { id: 7, animal: 'Гибрид зубра с бизоном, домашним скотом', price: '90 000' },
    { id: 8, animal: 'Медведи', price: '30 000' },
    { id: 9, animal: 'Барсук', price: '6 000' },
    { id: 10, animal: 'Сурки, бобры, куницы, харза', price: '3 000' },
    { id: 11, animal: 'Соболь, выдра', price: '5 000' },
    { id: 12, animal: 'Росомаха', price: '15 000' },
    { id: 13, animal: 'Рысь', price: '20 000' },
];
const data1 = [
    { id: 14, animal: 'Волк, лисица, шакал, енот-полоскун, енотовидная собака, ондатра', price: '100' },
    { id: 15, animal: 'Песец, корсак, дикие кошки, норки, хори, колонок, зайцы, дикий кролик', price: '500' },
    { id: 16, animal: 'Горностай, солонгой, ласка', price: '200' },
    { id: 17, animal: 'Белки', price: '250' },
    { id: 18, animal: 'Кроты, водяная полевка, хомяки, бурундуки, летяга, суслики', price: '50' },
    { id: 19, animal: 'Глухари', price: '3 000' },
    { id: 20, animal: 'Тетерев, фазаны, улары, саджа', price: '1 000' },
    { id: 21, animal: 'Гуси, казарки', price: '500' },
    { id: 22, animal: 'Утки, рябчик, куропатки, кеклик, голуби, лысуха, вальдшнеп', price: '300' },
    {
        id: 23,
        animal: 'Перепела, пастушок, обыкновенный погоныш, коростель, камышница, чибис, тулес, хрустан, камнешарка, турухтан, травник, улиты, мородунка, веретенники, кроншнепы, бекасы, дупеля, гаршнеп, горлицы',
        price: '100',
    },
];
export  {data, data1};